let messages = {
  index1: '切换语言',
  index2: '退出登录',
  index3: '首页',
  index4: '账户信息',
  index5: '入金',
  index6: '出金',
  index7: '转账',
  index8: '钱包',
  index9: '现金账户(MEQ)',
  index10: '代理信息',
  index11: '名下代理数',
  index12: '邀请客户数',
  index13: '添加代理',
  index14: '邀请链接',
  index15: '复制链接',
  index16: '待办事项',
  index17: '客户资料详情',
  index18: '申请出金',
  index19: '申请入金',
  index20: '个人信息',
  index21: '用户名',
  index22: '代理ID',
  index23: '注册时间',
  index24: '邮箱',
  index25: '登录密码',
  index26: '银行信息',
  index27: '开户人',
  index28: '银行名称',
  index29: '银行卡号',
  index30: '重置密码',
  index31: '请输入旧密码',
  index32: '请输入新密码',
  index33: '提交',
  index34: '修改银行卡信息',
  index35: '通知',
  index36: '转账成功',
  index37: '入金成功',
  index38: '出金成功',
  my1: '切换语言',
  my2: '退出登录',
  my3: '我的资金',
  my4: '入金',
  my5: '入金记录',
  my6: '入金类型',
  my7: '现金入金',
  my8: '现金账户',
  my9: '美元',
  my10: '入金金额',
  my11: '泰达币兑元股汇率',
  my12: '本地货币金额',
  my13: '入金凭证',
  my14: '请输入入金金额',
  my15: '请输入交易哈希值',
  my16: '钱包(MEQ)',
  my17: '转出金额',
  my18: '汇款银行',
  my19: '开户人',
  my20: '银行名称',
  my21: '银行卡号',
  my22: '立即提交',
  my23: '入金订单提交成功',
  my24: '订单将在1-2个工作日内完成审核',
  my25: '确定',
  my26: '转出成功',
  my27: '转账',
  my28: '转账记录',
  my29: '收款方',
  my30: '代理',
  my31: '用户',
  my32: '转账代理ID',
  my33: '请输入代理ID',
  my34: '转账用户ID',
  my35: '请输入用户ID',
  my36: '收款方用户名',
  my37: '现金账户(MEQ)',
  my38: '美元',
  my39: '转账金额',
  my40: '请输入转账金额',
  my41: '立即提交',
  my42: '转账成功',
  my43: '确定',
  my44: '出金',
  my45: '出金记录',
  my46: '现金账户余额',
  my47: '美元',
  my48: '出金金额',
  my49: '请输入出金金额',
  my50: '当前汇率',
  my51: '本地货币金额 ({n})',
  my52: '到账银行',
  my53: '出金申请提交成功',
  my54: '订单将在1-2个工作日内完成审核',
  my55: '确定',
  my56: '提示',
  my57: '您还未认证银行卡信息，请完善银行卡信息后再出金。',
  my58: '取消',
  my59: '立即完善',
  my60: '立即提交',
  my61: '钱包(MEQ)',
  my62: '转出至现金账户金额(MEQ)',
  my63: '请输入转出金额',
  my64: '钱包余额转出至现金账户',
  my65: '立即提交',
  my66: '流水号',
  my67: '钱包余额(MEQ)',
  my68: '转账金额(MEQ)',
  my69: '现金账户',
  my70: '转账时间',
  my71: '转账说明',
  my72: '佣金收入',
  my73: '转出现金账户',
  my74: '共{n}条',
  my75: '跳至{n}页',
  my76: '转出成功',
  my77: '确定',
  my78: '入金记录',
  my79: '状态',
  my80: '全部',
  my81: '待审批',
  my82: '审批通过',
  my83: '审批失败',
  my84: '入金时间',
  my85: '查询',
  my86: '流水号',
  my87: '入金金额(MEQ)',
  my201: '入金金额(MEQ)',
  my88: '入金金额(USDT)',
  my89: '入金汇率',
  my90: '现金账户余额(MEQ)',
  my91: '入金时间',
  my92: '交易哈希值',
  my93: '入金编号',
  my94: '审批备注',
  my95: '状态',
  my96: '操作',
  my97: '详情',
  my98: '关闭',
  my99: '共{n}条',
  my100: '{n}条/页',
  my101: '跳至{n}页',
  my102: '出金记录',
  my103: '状态',
  my104: '全部',
  my105: '待审批',
  my106: '审批通过',
  my107: '审批失败',
  my108: '出金时间',
  my109: '查询',
  my110: '流水号',
  my111: '出金金额(USDT)',
  my112: '出金金额(MEQ)',
  my113: '出金汇率',
  my114: '现金账户余额(MEQ)',
  my115: '出金时间',
  my116: '审批备注',
  my117: '状态',
  my118: '操作',
  my119: '详情',
  my120: '关闭',
  my121: '共{n}条',
  my122: '{n}条/页',
  my123: '跳至{n}页',
  my124: '账户转账记录',
  my125: '收款方',
  my126: '全部',
  my127: '代理',
  my128: '用户',
  my129: '转账类型',
  my130: '全部',
  my131: '转入',
  my132: '转出',
  my133: '转账ID',
  my134: '请输入转账ID',
  my135: '转账时间',
  my136: '查询',
  my137: '导出',
  my138: '流水号',
  my139: '收款方',
  my140: '转账ID',
  my141: '转账金额(MEQ)',
  my142: '当前现金账户余额($)',
  my143: '转账类型',
  my144: '转账时间',
  my145: '共x条',
  my146: 'x条/页',
  my147: '跳至x页',
  my148: '收款人用户ID',
  my149: '转账人用户名',
  my150: '请输入转账ID',
  my151: '请输入转账ID',
  my152: '请输入ID',
  my153: '代理ID/上级代理ID',
  my154: '转账时间',
  my155: '泰达币(USDT)',
  my156: '入金金额(MEQ)',
  my157: '备注',
  my401: '变动前余额（MEQ）',
  proxymoney1: '切换语言',
  proxymoney2: '退出登录',
  proxymoney3: '资金审核',
  proxymoney4: '代理入金审核',
  proxymoney5: '状态',
  proxymoney6: '全部',
  proxymoney7: '审批通过',
  proxymoney8: '审批失败',
  proxymoney9: '代理ID/上级代理ID',
  proxymoney10: '请输入代理ID/上级代理ID',
  proxymoney11: '入金时间',
  proxymoney12: '查询',
  proxymoney13: '导出',
  proxymoney14: '流水号',
  proxymoney15: '用户名',
  proxymoney16: '获佣代理ID',
  proxymoney17: '上级代理ID',
  proxymoney18: '入金金额({n})',
  proxymoney19: '入金金额($)',
  proxymoney20: '入金汇率',
  proxymoney21: '当前现金账户余额',
  proxymoney22: '入金时间',
  proxymoney23: '入金凭证',
  proxymoney24: '审批备注',
  proxymoney25: '状态',
  proxymoney26: '操作',
  proxymoney27: '审批',
  proxymoney28: '详情',
  proxymoney29: '通过',
  proxymoney30: '不通过',
  proxymoney31: '入金编号',
  proxymoney32: '请输入审批备注',
  proxymoney33: '审批状态',
  proxymoney34: '确定',
  proxymoney35: '取消',
  proxymoney36: '共x条',
  proxymoney37: 'x条/页',
  proxymoney38: '跳至x页',
  proxymoney39: '状态',
  proxymoney40: '全部',
  proxymoney41: '审批通过',
  proxymoney42: '审批失败',
  proxymoney43: '代理ID/上级代理ID',
  proxymoney44: '请输入代理名称',
  proxymoney45: '出金时间',
  proxymoney46: '查询',
  proxymoney47: '导出',
  proxymoney48: '流水号',
  proxymoney49: '用户名',
  proxymoney50: '代理ID',
  proxymoney51: '上级代理ID',
  proxymoney52: '出金金额({n})',
  proxymoney201: '出金金额(USDT)',
  proxymoney53: '出金金额(MEQ)',
  proxymoney54: '出金汇率',
  proxymoney55: '现金账户余额(MEQ)',
  proxymoney56: '出金时间',
  proxymoney57: '审批备注',
  proxymoney58: '状态',
  proxymoney59: '操作',
  proxymoney60: '审批',
  proxymoney61: '详情',
  proxymoney62: '银行信息',
  proxymoney63: '开户人',
  proxymoney64: '银行名称',
  proxymoney65: '银行卡号',
  proxymoney66: '开户支行',
  proxymoney67: '通过',
  proxymoney68: '不通过',
  proxymoney69: '取消',
  proxymoney70: '确定',
  proxymoney71: '请输入审批备注',
  proxymoney72: '关闭',
  proxymoney73: '审批状态',
  proxymoney74: '共x条',
  proxymoney75: 'x条/页',
  proxymoney76: '跳至x页',
  proxymoney77: '客户入金审核',
  proxymoney78: '状态',
  proxymoney79: '全部',
  proxymoney80: '审批通过',
  proxymoney81: '审批失败',
  proxymoney82: '用户ID/上级代理ID',
  proxymoney83: '请输入客户ID/上级代理ID',
  proxymoney84: '入金时间',
  proxymoney85: '查询',
  proxymoney86: '导出',
  proxymoney87: '流水号',
  proxymoney88: '用户名',
  proxymoney89: '领取用户ID',
  proxymoney90: '上级代理ID',
  proxymoney91: '入金金额({n})',
  proxymoney92: '入金金额($)',
  proxymoney93: '实际入金($)',
  proxymoney94: '入金汇率',
  proxymoney95: '当前现金账户余额',
  proxymoney96: '入金时间',
  proxymoney97: '交易哈希值',
  proxymoney98: '入金编号',
  proxymoney99: '审批备注',
  proxymoney100: '状态',
  proxymoney101: '操作',
  proxymoney102: '审批',
  proxymoney103: '修改',
  proxymoney104: '取消',
  proxymoney105: '确认修改',
  proxymoney106: '审批状态',
  proxymoney107: '关闭',
  proxymoney108: '请输入审批备注',
  proxymoney109: '确定',
  proxymoney110: '取消',
  proxymoney111: '请输入转账金额',
  proxymoney112: '共x条',
  proxymoney113: 'x条/页',
  proxymoney114: '跳至x页',
  proxymoney115: '客户出金审核',
  proxymoney116: '状态',
  proxymoney117: '全部',
  proxymoney118: '审批通过',
  proxymoney119: '审批失败',
  proxymoney120: '用户ID/上级代理ID',
  proxymoney121: '请输入客户ID/上级代理ID',
  proxymoney122: '出金时间',
  proxymoney123: '查询',
  proxymoney124: '导出',
  proxymoney125: '流水号',
  proxymoney126: '用户名',
  proxymoney127: '用户ID',
  proxymoney128: '上级代理ID',
  proxymoney129: '出金金额(本地货币)',
  proxymoney130: '出金金额($)',
  proxymoney131: '出金汇率',
  proxymoney132: '出金时间',
  proxymoney133: '审批备注',
  proxymoney134: '状态',
  proxymoney135: '操作',
  proxymoney136: '审批',
  proxymoney137: '详情',
  proxymoney138: '银行信息',
  proxymoney139: '开户人',
  proxymoney140: '银行名称',
  proxymoney141: '银行卡号',
  proxymoney142: '开户支行',
  proxymoney143: '通过',
  proxymoney144: '不通过',
  proxymoney145: '取消',
  proxymoney146: '确定',
  proxymoney147: '请输入审批备注',
  proxymoney148: '关闭',
  proxymoney149: '审批状态',
  proxymoney150: '共x条',
  proxymoney151: 'x条/页',
  proxymoney152: '跳至x页',
  proxyproxy1: '切换语言',
  proxyproxy2: '退出登录',
  proxyproxy3: '代理管理',
  proxyproxy4: '代理列表',
  proxyproxy5: '用户名/代理ID',
  proxyproxy6: '请输入用户名/代理ID',
  proxyproxy7: '查询',
  proxyproxy8: '导出',
  proxyproxy9: '创建代理',
  proxyproxy10: '用户名',
  proxyproxy11: '请输入代理用户名',
  proxyproxy12: '邮箱',
  proxyproxy13: '请输入邮箱',
  proxyproxy14: '登录密码',
  proxyproxy15: '请输入8-16位字母+数字',
  proxyproxy16: '返佣比例',
  proxyproxy17: '请输入返佣比例%',
  proxyproxy18: '小于等于比例{n}%',
  proxyproxy19: '利息比例',
  proxyproxy20: '请输入利息比例%',
  proxyproxy21: '小于等于比例{n}%',
  proxyproxy22: '代理ID',
  proxyproxy23: '上级代理ID',
  proxyproxy24: '代理类型',
  proxyproxy25: '渠道代理',
  proxyproxy26: '代理等级',
  proxyproxy27: '返佣比例',
  proxyproxy28: '利息比例',
  proxyproxy29: '钱包余额(MEQ)',
  proxyproxy30: '现金账户余额(MEQ)',
  proxyproxy31: '注册时间',
  proxyproxy32: '操作',
  proxyproxy33: '编辑',
  proxyproxy34: '取消',
  proxyproxy35: '邀请下级',
  proxyproxy36: '确定',
  proxyproxy37: '共{n}条',
  proxyproxy38: '{n}条/页',
  proxyproxy39: '跳至x页',
  proxyproxy40: '代理业绩报表',
  proxyproxy41: '用户/代理ID',
  proxyproxy42: '请输入用户/代理ID',
  proxyproxy43: '查询',
  proxyproxy44: '导出',
  proxyproxy45: '用户名',
  proxyproxy46: '代理ID',
  proxyproxy47: '上级代理ID',
  proxyproxy48: '名下用户数',
  proxyproxy49: '名下总入金(MEQ)',
  proxyproxy50: '名下总出金(MEQ)',
  proxyproxy51: '成交总金额({n})',
  proxyproxy52: '返佣总金额({n})',
  proxyproxy53: '资金使用费({n})',
  proxyproxy54: '共{n}条',
  proxyproxy55: '{n}条/页',
  proxyproxy56: '跳至{n}页',
  proxyproxy57: '所有用户通过邀请关系发展直属用户，代理等级由系统按条件自动升级。',
  proxyproxy58: '达到升级条件后，用户依次升级为三级代理、二级代理、一级代理。',
  proxyproxy59: '代理返佣将根据平台规则与实际交易数据进行结算。',
  proxyproxy60: '代理创建成功',
  proxyproxy61: '代理信息已更新',
  proxyproxy62: '请输入有效比例',
  proxycust1: '切换语言',
  proxycust2: '退出登录',
  proxycust3: '用户管理',
  proxycust4: '用户名/用户ID/交易账号',
  proxycust5: '请输入',
  proxycust6: '状态',
  proxycust7: '全部',
  proxycust8: '审批通过',
  proxycust9: '审批失败',
  proxycust10: '查询',
  proxycust11: '导出',
  proxycust12: '创建用户',
  proxycust13: '用户名',
  proxycust14: '请输入用户名',
  proxycust15: '用户ID',
  proxycust16: '登录密码',
  proxycust17: '请输入8-16位字母+数字',
  proxycust18: '杠杆比例',
  proxycust19: '请输入杠杆比例',
  proxycust20: '融资倍数',
  proxycust21: '请输入融资倍数',
  proxycust22: '取消',
  proxycust23: '创建用户',
  proxycust24: '用户名',
  proxycust25: '用户ID',
  proxycust26: '交易账号',
  proxycust27: '杠杆比例',
  proxycust28: '融资倍数',
  proxycust29: '现金账户余额(MEQ)',
  proxycust30: '交易账户余额(MEQ)',
  proxycust31: '首次入金时间',
  proxycust32: '注册时间',
  proxycust33: '状态',
  proxycust34: '操作',
  proxycust35: '审批',
  proxycust36: '详情',
  proxycust37: '通过',
  proxycust38: '不通过',
  proxycust39: '审批备注',
  proxycust40: '请输入审批备注',
  proxycust41: '关闭',
  proxycust42: '取消',
  proxycust43: '确定',
  proxycust44: '身份信息',
  proxycust45: '身份证正面',
  proxycust46: '身份证反面',
  proxycust47: '共x条',
  proxycust48: 'x条/页',
  proxycust49: '跳至x页',
  proxycust50: '交易费用明细',
  proxycust51: '用户名/交易账号',
  proxycust52: '请输入用户名/交易账号',
  proxycust53: '交易类型',
  proxycust54: '日交易',
  proxycust55: '融资',
  proxycust56: '交易费用收取时间',
  proxycust57: '查询',
  proxycust58: '导出',
  proxycust59: '用户名',
  proxycust60: '交易账号',
  proxycust61: '交易类型',
  proxycust62: '交易费用($)',
  proxycust63: '订单流水号',
  proxycust64: '交易费用收取时间',
  proxycust65: '共x条',
  proxycust66: 'x条/页',
  proxycust67: '跳至x页',
  proxycust68: '用户股票交易记录',
  proxycust69: '交易时间',
  proxycust70: '开平仓',
  proxycust71: '开仓',
  proxycust72: '平仓',
  proxycust73: '买/卖',
  proxycust74: '买',
  proxycust75: '卖',
  proxycust76: '全部',
  proxycust77: '交易产品',
  proxycust78: '请输入交易产品',
  proxycust79: '用户名/交易账号',
  proxycust80: '请输入用户名/交易账号',
  proxycust81: '查询',
  proxycust82: '导出',
  proxycust83: '总盈亏($)',
  proxycust84: '用户名',
  proxycust85: '交易账号',
  proxycust86: '交易单号',
  proxycust87: '交易产品',
  proxycust88: '交易价格',
  proxycust89: '开平仓',
  proxycust90: '买/卖',
  proxycust91: '交易量',
  proxycust92: '手续费($)',
  proxycust93: '盈利',
  proxycust94: '交易时间',
  proxycust95: '共x条',
  proxycust96: 'x条/页',
  proxycust97: '跳至x页',
  proxycust98: '客户融资交易记录',
  proxycust99: '交易时间',
  proxycust100: '开平仓',
  proxycust101: '开仓',
  proxycust102: '平仓',
  proxycust103: '买/卖',
  proxycust104: '买',
  proxycust105: '卖',
  proxycust106: '全部',
  proxycust107: '交易产品',
  proxycust108: '请输入交易产品',
  proxycust109: '用户名/交易账号',
  proxycust110: '请输入用户名/交易账号',
  proxycust111: '查询',
  proxycust112: '导出',
  proxycust113: '总盈亏($)',
  proxycust114: '用户名',
  proxycust115: '交易账号',
  proxycust116: '交易单号',
  proxycust117: '交易产品',
  proxycust118: '交易价格',
  proxycust119: '开平仓',
  proxycust120: '买/卖',
  proxycust121: '交易量',
  proxycust122: '利息($)',
  proxycust123: '盈利',
  proxycust124: '交易时间',
  proxycust125: '共x条',
  proxycust126: 'x条/页',
  proxycust127: '跳至x页',
  proxycust128: '请输入',
  proxymoneymanage1: '切换语言',
  proxymoneymanage2: '退出登录',
  proxymoneymanage3: '资金管理',
  proxymoneymanage4: '用户交易账户转账明细',
  proxymoneymanage5: '用户名/交易账号',
  proxymoneymanage6: '请输入用户名/交易账号',
  proxymoneymanage7: '转账类型',
  proxymoneymanage8: '全部',
  proxymoneymanage9: '入金',
  proxymoneymanage10: '出金',
  proxymoneymanage11: '转账时间',
  proxymoneymanage12: '查询',
  proxymoneymanage13: '导出',
  proxymoneymanage14: '流水号',
  proxymoneymanage15: '用户名',
  proxymoneymanage16: '交易账号',
  proxymoneymanage17: '转账金额($)',
  proxymoneymanage18: '转账金额({n})',
  proxymoneymanage19: '转账汇率',
  proxymoneymanage20: '转账类型',
  proxymoneymanage21: '转账时间',
  proxymoneymanage22: '共x条',
  proxymoneymanage23: 'x条/页',
  proxymoneymanage24: '跳至x页',
  proxymoneymanage25: '佣金明细',
  proxymoneymanage26: '代理用户/代理ID/用户ID/交易账号',
  proxymoneymanage27: '请输入',
  proxymoneymanage28: '账户类型',
  proxymoneymanage29: '全部',
  proxymoneymanage30: '日交易',
  proxymoneymanage31: '融资',
  proxymoneymanage32: '交易时间',
  proxymoneymanage33: '查询',
  proxymoneymanage34: '导出',
  proxymoneymanage35: '代理用户名',
  proxymoneymanage36: '代理ID',
  proxymoneymanage37: '代理等级',
  proxymoneymanage38: '账户类型',
  proxymoneymanage39: '返佣比例',
  proxymoneymanage40: '手续费(MEQ)',
  proxymoneymanage41: '手续费(MEQ)',
  proxymoneymanage42: '汇率',
  proxymoneymanage43: '佣金(MEQ)',
  proxymoneymanage44: '交易用户ID',
  proxymoneymanage45: '交易账号',
  proxymoneymanage46: '交易产品',
  proxymoneymanage47: '交易量',
  proxymoneymanage48: '交易价格',
  proxymoneymanage49: '开平仓',
  proxymoneymanage50: '开仓',
  proxymoneymanage51: '平仓',
  proxymoneymanage52: '买/卖',
  proxymoneymanage53: '买',
  proxymoneymanage54: '卖',
  proxymoneymanage55: '流水号',
  proxymoneymanage56: '交易时间',
  proxymoneymanage57: '共x条',
  proxymoneymanage58: 'x条/页',
  proxymoneymanage59: '跳至x页',
  proxymoneymanage60: '转账金额(MEQ)',
  proxymoneymanage61: '本地金额({n})',
  proxymoneymanage62: '请输入',
  proxymoneymanage63: '账户类型',
  proxymoneymanage64: '日内交易账户',
  proxymoneymanage65: '融资交易账户',
  user1: '切换语言',
  user2: '退出登录',
  user3: '注册账户',
  user4: '请输入用户名',
  user5: '用户ID',
  user6: '请输入8-16位字母+数字密码',
  user7: '确认密码',
  user8: '请输入邮箱(非必填)',
  user9: '请输入手机号(非必填)',
  user10: '邀请码',
  user11: '立即注册',
  user12: '已有账户？立即登录',
  user13: '该用户名已存在，请填写其他用户名',
  user14: '密码不符合要求，请输入8~16位 字母+数字密码',
  user15: '确认密码输入错误',
  user16: '邮箱验证码填写错误',
  user17: '阅读并接受《服务条款》和《隐私政策》',
  user18: '人工验证',
  user19: '请按顺序点击图片上的字母',
  user20: '重新加载',
  user21: '提交验证',
  user22: '验证错误，请重新验证',
  user23: '登录',
  user24: '请输入用户名/用户ID',
  user25: '请输入密码',
  user26: '登录',
  user27: '首页',
  user28: '账户信息',
  user29: '入金',
  user30: '出金',
  user31: '转账',
  user32: '现金账户余额(MEQ)',
  user33: '总资产',
  user34: '总资产 = 现金账户余额 + 日内交易账户权益 + 融资交易账户权益',
  user35: '交易信息',
  user36: '交易账号',
  user37: '交易密码',
  user38: '复制',
  user39: '交易账户概览',
  user40: '交易账户入金',
  user41: '交易账号出金',
  user42: '交易账号',
  user43: '杠杆比例',
  user44: '账户净值(MEQ)',
  user45: '融资交易账户',
  user46: '融资倍数',
  user47: '{n}倍',
  user48: '账户余额($)',
  user49: '个人信息',
  user50: '用户名',
  user51: '用户ID',
  user52: '交易账号',
  user53: '注册时间',
  user54: '邮箱',
  user55: '登录密码',
  user56: '手机号码',
  user57: '身份信息',
  user58: '身份证正面',
  user59: '身份证反面',
  user60: '银行信息',
  user61: '开户人',
  user62: '银行名称',
  user63: '银行卡号',
  user64: '身份信息补充',
  user65: '未填写',
  user66: '请输入开户人姓名',
  user67: '请输入银行名称',
  user68: '请输入银行卡卡号',
  user69: '请输入开户支行',
  user70: '取消',
  user71: '确定',
  user72: '修改用户名',
  user73: '原用户名',
  user74: '请输入新用户名',
  user75: '修改手机号码',
  user76: '旧手机号码',
  user77: '请输入新手机号码',
  user78: '邮箱修改',
  user79: '旧邮箱',
  user80: '请输入新邮箱',
  user81: '重置密码',
  user82: '请输入旧密码',
  user83: '请输入新密码',
  user84: '提交',
  user85: '修改手机号码',
  user86: '修改银行卡信息',
  user87: '通知',
  user88: '转账成功',
  user89: '入金成功',
  user90: '出金成功',
  user91: '忘记密码',
  user92: '请输入新密码(8～16位 字母+数字)',
  user93: '请输入邮箱验证码',
  user94: '获取验证码',
  user95: '重新获取验证码',
  user96: '验证码输入错误',
  user97: '返回登录',
  user98: '请输入用户名/用户ID',
  user99: '请输入确认密码',
  user100: '请输入邀请码(非必填)',
  user101: '阅读并接受',
  user102: '服务条款',
  user103: '和',
  user104: '隐私政策',
  user105: '重置密码',
  user106: '交易账户ID',
  user107: '交易账户密码',
  user108: '转入交易账户',
  user109: '转入现金账户',
  user110: '交易密码已重置',
  user111: '请输入登录密码',
  user112: '确认交易密码',
  user113: 'USDT钱包地址',
  user114: '请输入登录密码',
  user115: '划转方向',
  user116: '输入登录密码进行验证',
  user117: '可转账金额',
  user118: '收款方用户名',
  user119: '转账规则',
  user120: '请确认收款方用户名与实际收款人一致。如不一致，请先确认收款人 ID 后再转账。',
  user121: '转账提交后立即生效，请谨慎操作。',
  user122: '请确认账户、方向和金额无误后再提交',
  user123: '交易账户余额不足',
  user124: '现金账户余额不足',
  user125: '请输入正确的出金金额',
  usermoney1: '切换语言',
  usermoney2: '退出登录',
  usermoney3: '我的资金',
  usermoney4: '入金',
  usermoney5: '入金记录',
  usermoney6: '现金账户余额(MEQ)',
  usermoney7: '美元',
  usermoney8: '入金金额',
  usermoney9: '当前汇率',
  usermoney10: '本地货币金额',
  usermoney11: '入金凭证',
  usermoney12: '请输入入金金额',
  usermoney13: '请输入交易哈希值',
  usermoney14: '钱包',
  usermoney15: '转出金额',
  usermoney16: '汇款银行',
  usermoney17: '开户人',
  usermoney18: '银行名称',
  usermoney19: '银行卡号',
  usermoney20: '立即提交',
  usermoney21: '入金订单提交成功',
  usermoney22: '订单将在1-2个工作日内完成审核',
  usermoney23: '确定',
  usermoney24: '转出成功',
  usermoney25: '转账',
  usermoney26: '转账记录',
  usermoney27: '转账类型',
  usermoney28: '交易账户转账',
  usermoney29: '转账给代理',
  usermoney30: '转账操作',
  usermoney31: '转入至交易账户',
  usermoney32: '转出至现金账户',
  usermoney33: '收款代理ID',
  usermoney34: '请输入代理ID',
  usermoney35: '收款方用户名',
  usermoney36: '交易账户',
  usermoney37: '日内账户',
  usermoney38: '融资账户',
  usermoney39: '美元',
  usermoney40: '现金账户余额',
  usermoney41: '当前账户余额',
  usermoney42: '转账金额',
  usermoney43: '请输入转账金额',
  usermoney44: '立即提交',
  usermoney45: '转账成功',
  usermoney46: '确定',
  usermoney47: '出金',
  usermoney48: '出金记录',
  usermoney49: '现金账户余额',
  usermoney50: '美元',
  usermoney51: '出金金额',
  usermoney52: '请输入出金金额',
  usermoney53: '当前汇率',
  usermoney54: '本地货币金额',
  usermoney55: '到账银行',
  usermoney56: '出金申请提交成功',
  usermoney57: '订单将在1-2个工作日内完成审核',
  usermoney58: '确定',
  usermoney59: '提示',
  usermoney60: '您还未认证银行卡信息，请完善银行卡信息后再出金。',
  usermoney61: '取消',
  usermoney62: '立即完善',
  usermoney63: '立即提交',
  usermoney64: '净盈亏',
  usermoney65: 'USDT地址',
  usermoney66: '钱包二维码',
  usermoney67: '元股介绍',
  usermoney68: 'HeyMeta 的基础货币为元股 Meta Equity(MEQ)。元股(MEQ) 与 泰达币(USDT)按 1:1 锚定，可用于平台入金、转账、交易账户划转及生态权益结算。',
  usermoney69: '价差盈亏',
  usermoney70: 'MEQ 与 USDT 按 1:1 锚定',
  usermoney71: '可用于入金、转账和交易账户划转',
  usermoney72: '金额以系统实时汇率为准',
  usermoney73: '请确认钱包网络与地址无误',
  usermoney74: '链上到账时间以网络确认为准',
  usermoney75: '平台不会索要您的助记词或私钥',
  usermoney76: '请勿向陌生人透露账户信息',
  usermoney77: '转账到账后可在资金流水中查看',
  usermoney78: '交易哈希值提交后不可修改',
  usermoney79: '如有疑问，请联系在线客服',
  usermoney80: '安全提示',
  userstatement1: '切换语言',
  userstatement2: '退出登录',
  userstatement3: '报表管理',
  userstatement4: '入金记录',
  userstatement5: '转账类型',
  userstatement6: '全部',
  userstatement7: '银行卡入金',
  userstatement8: '内转',
  userstatement9: '状态',
  userstatement10: '全部',
  userstatement11: '待审批',
  userstatement12: '审批通过',
  userstatement13: '审批失败',
  userstatement14: '入金时间',
  userstatement15: '查询',
  userstatement16: '导出',
  userstatement17: '流水号',
  userstatement18: '入金金额(本地货币)',
  userstatement19: '入金金额($)',
  userstatement20: '入金汇率',
  userstatement21: '当前现金账户余额',
  userstatement22: '实际入金',
  userstatement23: '转账类型',
  userstatement24: '入金时间',
  userstatement25: '交易哈希值',
  userstatement26: '入金编号',
  userstatement27: '审批备注',
  userstatement28: '状态',
  userstatement29: '操作',
  userstatement30: '详情',
  userstatement31: '关闭',
  userstatement32: '共x条',
  userstatement33: 'x条/页',
  userstatement34: '跳至x页',
  userstatement35: '出金记录',
  userstatement36: '状态',
  userstatement37: '全部',
  userstatement38: '待审批',
  userstatement39: '审批通过',
  userstatement40: '审批失败',
  userstatement41: '出金时间',
  userstatement42: '查询',
  userstatement43: '流水号',
  userstatement44: '出金金额(本地货币)',
  userstatement45: '出金金额($)',
  userstatement46: '出金汇率',
  userstatement47: '当前现金账户余额',
  userstatement48: '出金时间',
  userstatement49: '审批备注',
  userstatement50: '状态',
  userstatement51: '操作',
  userstatement52: '详情',
  userstatement53: '审批状态',
  userstatement54: '关闭',
  userstatement55: '共x条',
  userstatement56: 'x条/页',
  userstatement57: '跳至x页',
  userstatement58: '交易账户转账记录',
  userstatement59: '交易账户',
  userstatement60: '全部',
  userstatement61: '日内账户',
  userstatement62: '融资账户',
  userstatement63: '转账时间',
  userstatement64: '查询',
  userstatement65: '流水号',
  userstatement66: '转账金额($)',
  userstatement67: '本地货币金额',
  userstatement68: '转账汇率',
  userstatement69: '交易账户',
  userstatement70: '交易账户可用余额',
  userstatement71: '转账时间',
  userstatement72: '共x条',
  userstatement73: 'x条/页',
  userstatement74: '跳至x页',
  userstatement75: '代理转账记录',
  userstatement76: '转账类型',
  userstatement77: '全部',
  userstatement78: '转入至交易账户',
  userstatement79: '转出至现金账户',
  userstatement80: '转账时间',
  userstatement81: '查询',
  userstatement82: '流水号',
  userstatement83: '转账ID',
  userstatement84: '请输入转账ID',
  userstatement85: '转账金额($)',
  userstatement86: '当前现金账户余额',
  userstatement87: '转账类型',
  userstatement88: '转账时间',
  userstatement89: '共x条',
  userstatement90: 'x条/页',
  userstatement91: '跳至x页',
  userstatement92: '交易记录',
  userstatement93: '交易时间',
  userstatement94: '开平仓',
  userstatement95: '开仓',
  userstatement96: '平仓',
  userstatement97: '买/卖',
  userstatement98: '买',
  userstatement99: '卖',
  userstatement100: '全部',
  userstatement101: '交易产品',
  userstatement102: '请输入交易产品',
  userstatement103: '查询',
  userstatement104: '导出',
  userstatement105: '总盈利($)',
  userstatement106: '交易单号',
  userstatement107: '交易产品',
  userstatement108: '交易价格',
  userstatement109: '开平仓',
  userstatement110: '买/卖',
  userstatement111: '交易量',
  userstatement112: '手续费({n})',
  userstatement113: '盈利',
  userstatement114: '交易时间',
  userstatement115: '共x条',
  userstatement116: 'x条/页',
  userstatement117: '跳至x页',
  userstatement118: '融资交易记录',
  userstatement119: '交易时间',
  userstatement120: '开平仓',
  userstatement121: '开仓',
  userstatement122: '平仓',
  userstatement123: '买/卖',
  userstatement124: '买',
  userstatement125: '卖',
  userstatement126: '全部',
  userstatement127: '交易产品',
  userstatement128: '请输入交易产品',
  userstatement129: '查询',
  userstatement130: '导出',
  userstatement131: '总盈利($)',
  userstatement132: '交易单号',
  userstatement133: '交易产品',
  userstatement134: '交易价格',
  userstatement135: '开平仓',
  userstatement136: '买/卖',
  userstatement137: '交易量',
  userstatement138: '利息({n})',
  userstatement139: '盈利',
  userstatement140: '交易时间',
  userstatement141: '共x条',
  userstatement142: 'x条/页',
  userstatement143: '跳至x页',
  public1: '资金审核',
  public2: '代理出金审核',
  public3: '代理业绩列表',
  public4: '用户明细',
  public5: '个人信息',
  public6: '资金管理',
  public7: '客户管理',
  public8: '请输入用户名',
  public9: '用户名已经存在，请填写其他用户名',
  public10: '请输入邮箱',
  public11: '邮箱格式有误，请重填',
  public12: '密码长度不能小于8位',
  public13: '密码长度不能大于16位',
  public14: '必须同时包含数字和字母',
  public15: '注册成功',
  public16: '修改成功',
  public17: '请选择',
  public18: '全部状态',
  public19: '已审批通过',
  public20: '请输入',
  public21: '创建成功',
  public22: '开始日期',
  public23: '结束日期',
  public24: '请选择交易账户',
  public25: '总佣金',
  public26: '添加客户',
  public27: '复制成功',
  public28: '继续转账',
  public29: '请输入数字',
  public30: '请输入正确的金额，并且大于$10',
  public31: '请输入Swift Code',
  public32: '审核失败',
  public33: '未上传',
  public34: '待审核',
  public35: '已审核',
  public36: '审核失败',
  public37: '您还未认证银行卡信息，请完善银行卡信息后再入金。',
  public38: '当前美元兑人民币汇率',
  public39: '找回密码',
  public40: '验证码发送',
  public41: '请输入验证码',
  public42: '还没有账号？',
  public43: '请输入手机号码(非必填)',
  public44: '邀请码(非必填)',
  public45: '已有账号？',
  public46: '向右滑动',
  public47: '请输入手机号码',
  public48: '请再次输入密码',
  public49: '两次输入密码不一致!',
  public50: '重置交易密码',
  public51: '交易账户可用余额',
  public52: '当前的汇率是',
  public53: '修改身份证',
  public54: '请上传身份证正面',
  public55: '请上传身份证反面',
  public56: '您的认证信息已提交',
  public57: '提交成功',
  public58: '修改邮箱',
  public59: '请输入新邮箱地址',
  public60: '提交认证',
  public61: '请输入银行卡号',
  public62: '您的认证信息已提交',
  public63: '上传图片大小不能超过 2MB',
  public64: '上传',
  public65: '提示',
  public66: '代理入金待审批',
  public67: '用户入金待审核',
  public68: '代理出金待审核',
  public69: '用户出金待审批',
  public70: '用户资料待审批',
  public71: '转账金额(MEQ)',
  public72: '交易账户ID',
  public73: '登录',
  public74: '修改成功',
  public75: '修改成功',
  public76: '修改成功',
  public77: '注册',
  public78: '用户名或者id不存在',
  public79: '交易账户ID',
  public80: '融资交易账户',
  public81: '元股兑泰达币汇率',
  public82: '类型',
  public83: '标题',
  public84: '时间',
  public85: '系统通知',
  public86: '资金通知',
  public87: '交易通知',
  public88: '活动通知',
  public89: '已读',
  public90: '未读',
  text1: '元股(MEQ)',
  text2: '交易哈希值',
  text3: '请输入USDT数量',
  text4: '邮箱验证码',
  text5: '请输入转出USDT地址',
  text6: '赠金激励报表',
  text7: '领取风险补偿',
  text8: '亏损抵扣',
  text9: '累计风险补偿',
  text10: '抵扣后补偿金余额',
  text11: '待领取补偿',
  text12: '手动领取',
  text13: '自动领取',
  text14: '流水号',
  text15: '总资产',
  text16: '本次领取金额(MEQ-A)',
  text17: '风险补偿比例',
  text18: '可用补偿金(MEQ-A)',
  text19: '发放时间',
  text20: '领取时间',
  text21: '领取方式',
  text22: '已抵扣金额',
  text23: '可抵扣金额',
  text24: '抵扣亏损',
  text25: '流水号',
  text26: '抵扣金额(MEQ)',
  text27: '补偿金余额',
  text28: '现金账户余额(MEQ)',
  text29: '亏损结算时间',
  text30: '抵扣时间',
  text31: '说明',
  text32: '1. 领取资格：',
  text33: '(1)完成注册并符合平台活动规则的用户，可参与赠金激励计划；',
  text34: '(2)赠金将根据账户资产、入金情况、活动规则及系统记录进行计算与发放；',
  text35: '(3)具体计算方式、比例及发放时间以平台公告和系统记录为准；',
  text36: '(4)赠金仅作为权益额度或风险缓冲工具使用，不构成可提现资金。',
  text37: '(5)用户可每周手动领取，可一次领取多份新币；也可设置自动领取。',
  text38: '2.使用规则：',
  text39: '(1)信用账户内的新币，用于兑换交易亏损额；',
  text40: '2)信用账户内的新币额度低于交易亏损额度时，先兑换信用账户内的额度，剩余亏损额',
  text41: '待使用',
  text42: '已使用',
  text43: '自动领取',
  text44: '手动领取',
  text45: '风险补偿总览(MEQ)',
  text46: '风险补偿领取记录',
  text47: '风险补偿抵扣记录',
  text48: '风险补偿佣金明细',
  text49: '领取时间',
  text50: '领取方式',
  text51: '上级代理',
  text52: '计算时间',
  text53: '赠金总金额',
  text54: '本次抵扣金额',
  text55: '使用赠金总金额',
  text56: '补偿金佣金比例（%）',
  text57: '佣金金额(MEQ)',
  text58: '佣金总金额',
  text59: '钱包地址',
  text60: '钱包类型',
  text61: '修改助记词',
  text62: '您的初始助记词已生成，助记词为',
  text63: '助记词',
  text64: '请输入助记词',
  text65: '请输入英文或者数字',
  text66: '领取',
  text67: '元股',
  text68: '更多',
  text69: '<h3>一、什么是 HeyMeta 赠金激励计划？</h3>\n<p>HeyMeta 赠金激励计划由每日成长赠金(MEQ-P)与风险补偿赠金(MEQ-A)组成，旨在为用户提供长期激励与交易风险缓冲。</p>\n<p>用户完成注册、入金、交易等真实行为后，可按平台规则持续累积 MEQ-P；满足激活条件后，MEQ-P 将转化为可用于抵扣交易亏损的 MEQ-A。</p>\n<h3>二、如何参与？</h3>\n<p><strong>① 注册账户</strong>：注册成功后，系统将开始记录并累计每日成长赠金(MEQ-P)。</p>\n<p><strong>② 完成入金</strong>：符合条件的入金可触发激活，系统将按规则把可激活额度转化为风险补偿赠金(MEQ-A)。</p>\n<p><strong>③ 保持账户活跃</strong>：持续参与平台交易与生态行为，有助于获得更多平台权益。</p>\n<h3>三、赠金用途</h3>\n<p>MEQ-A 仅用于在符合规则的交易亏损场景下自动抵扣，不可提现、转让或作为交易本金使用。</p>\n<p>MEQ-P 为待激活权益，不具备资金属性，需满足平台规则后方可激活。</p>\n<h3>四、风险提示</h3>\n<p>所有交易均存在风险。赠金仅作为风险缓冲工具，不代表收益保证或本金保障。</p>\n<p>平台将根据风控规则识别异常行为，并保留调整、冻结或收回相关权益的权利。</p>',
  text70: '赠金激励规则',
  text71: '元股奖励排名 Top',
  text72: '入金金额(MEQ)',
  text73: '净入金',
  text74: '奖励比例',
  text75: '天数',
  text76: '激活金额(MEQ-A)',
  text77: '领取日期',
  text78: '奖励基准额度',
  text79: '每日赠金金额(MEQ-P)',
  text80: '元股奖励(MEQ)',
  text81: '当前奖励基数',
  text82: '可激活赠金(MEQ-P)',
  text83: '累计成长赠金(MEQ-P)',
  text183: '成长赠金总额(MEQ-P)',
  text84: '累计元股奖励(MEQ)',
  text85: '已激活风险补偿赠金(MEQ-A)',
  text185: '已激活赠金(MEQ-A)',
  text86: '激活金额(MEQ-A)',
  text87: '请妥善保管以下助记词，它是找回帐户的的唯一凭证，请勿泄漏或遗失管您的助记词，它可用于在您忘记密码时找回帐户。',
  text88: '如有需要，您也可以修改为更容易记的助记词，方便日后管理和恢复帐户',
  text89: '助记词只能修改一次',
  text90: '长度需为10-12位，数字或英文字母',
  text91: '您的新助记词为',
  text92: '请妥善保管您的助记词，忘记密码时可通过助记词找回帐户。',
  text93: '请注意：若同时遗忘密码和助记词，您的帐户将无法找回。',
  text94: '助记词修改成功',
  text95: '赠金类型',
  text96: '风险补偿赠金',
  text97: '成长赠金激活',
  text98: '领取成长赠金',
  text99: '成长赠金总览',
  text100: '成长赠金领取记录',
  text101: '成长赠金激活记录',
  text102: '激活记录',
  text103: '总成长赠金(MEQ-P)',
  text104: '累计获得元股(MEQ)',
  text105: '日期',
  text106: '已激活风险补偿赠金(MEQ-A)',
  text107: '金额',
  text108: '跑马灯记录',
  text109: '激活日期',
  text110: '股息比例',
  text111: '股息金额',
  text112: '存入现金账户',
  text113: '当前持有股份',
  text114: '累计获得股息',
  text115: '股息',
  text116: '股息记录',
  text117: '发放时间',
  text319: '风险补偿赠金规则(MEQ-A)',
  text320: '一、定义',
  text321: '二、获取方式',
  text322: '三、使用规则',
  text323: '四、使用限制',
  text324: '五、风险提示',
  text325: '六、风控与违规处理',
  text326: '七、规则调整与最终解释权',
  text133: '风险补偿赠金(Active Meta Equity，简称“MEQ-A”)系已完成激活的权益额度，仅用于抵扣交易亏损，不构成用户可自由支配资金。',
  text134: '用户可通过以下方式获得MEQ-A：',
  text135: '1.待激活元股转化。',
  text136: '2.账户余额奖励。平台可根据用户账户总资产及相关规则，按日计算并发放一定比例的MEQ-A。 公式为：',
  text137: 'MEQ-A=账户总资产*奖励比例',
  text139: '1.MEQ-A仅可用于抵扣用户在平台交易过程中产生的亏损。',
  text140: '2.MEQ-A仅在发生亏损时按系统规则自动使用，不支持手动操作。',
  text141: '3.MEQ-A不得用于开仓、加仓或作为保证金使用。',
  text142: 'MEQ-A属于赠金性质权益，明确不具备资金属性，并受以下限制：',
  text143: '1.不得提现、转让或变现；',
  text144: '2.不得用于交易本金或参与收益分配；',
  text145: '3.不构成用户资产或平台负债；',
  text146: '4.不产生利息或任何形式收益；',
  text147: '5.不构成平台对用户收益或本金安全的承诺。',
  text148: '1.用户理解并同意，平台提供的MEQ-A仅作为风险缓冲工具，不代表任何收益保障。',
  text149: '2.所有交易行为均存在风险，用户应独立判断并自行承担交易损失。',
  text150: '3.平台不对用户因交易产生的任何损失承担赔偿责任(法律另有规定的除外)。',
  text151: '1.如平台发现用户存在套利、刷赠金、对冲交易或其他异常行为，有权：',
  text152: '1).冻结或收回MEQ-A；',
  text153: '2).取消用户参与资格；',
  text154: '3).追究相关责任。',
  text155: '2.平台有权对异常账户进行审查，并采取必要的限制措施。',
  text156: '1.平台有权根据业务需要对MEQ-A的获取方式、使用规则及相关条款进行调整。',
  text157: '2.相关调整将以公告形式发布，并自公告之日起生效。',
  text158: '3.在法律允许范围内，本规则的最终解释权归平台所有。',
  text329: '每日成长赠金规则(MEQ-P)',
  text330: '一、定义',
  text331: '二、发放规则',
  text332: '三、权益属性',
  text333: '四、激活机制',
  text334: '五、失效与处理',
  text335: '六、规则变更',
  text233: '每日成长赠金(Pending Meta Equity，简称“MEQ-P”)系平台基于既定规则向用户发放的待激活权益额度，不构成用户实际资产或可支配资金。',
  text234: '1.用户完成平台注册后，即视为参与本活动。',
  text235: '2.平台根据设定的奖励基础和奖励比例，按日计算并给用户发放MEQ-P。',
  text236: '3.MEQ-P按自然日发放，具体发放时间及比例以平台系统记录为准。',
  text237: '4.MEQ-P可在未激活状态下持续累计。',
  text239: 'MEQ-P仅为未激活权益，不具备资金属性，且明确具有以下限制：',
  text240: '1.不得用于任何形式的交易；',
  text241: '2.不得用于抵扣交易亏损；',
  text242: '3.不得提现、转让、赠与或变现；',
  text243: '4.不产生利息、收益或其他形式的回报；',
  text244: '5.不构成存款、资产或任何形式的收益承诺。',
  text245: '1.当用户满足平台设定的激活条件(包括但不限于完成入金等行为)后，MEQ-P将自动转化为风险补偿赠金(MEQ-A)，激活公式为：',
  text246: '可激活MEQ-P =(本次入金 - 上次激活后的总出金)× 奖励比例 × 持续天数',
  text247: '2.转化比例、条件及具体规则以平台实时公布为准。',
  text248: '3.转化完成后，对应的MEQ-P将不再保留。',
  text249: '1.如用户账户存在异常、违规操作或违反平台规则行为，平台有权取消或清除其MEQ-P权益。',
  text250: '2.如用户长期未满足激活条件，平台有权根据运营规则对MEQ-P进行调整或失效处理。',
  text251: '平台有权根据业务发展需要，对MEQ-P的发放标准、计算方式及激活规则进行调整，并通过公告形式提前通知。',
  fundstreams1: '资金流水',
  fundstreams2: '流水号',
  fundstreams3: '时间',
  fundstreams4: '变动金额(MEQ)',
  fundstreams5: '变动后现金账户余额(MEQ)',
  fundstreams6: '操作来源',
  fundstreams7: '款项说明',
  fundstreams8: '账户来源',
  fundstreams9: '钱包',
  fundstreams10: '现金账户',
  fundstreams11: '交易账户',
  fundstreams12: '每日成长赠金',
  fundstreams13: '风险补偿赠金',
  user126: '请输入用户中心密码',
  transferrecord1: '收到他人转账',
  transferrecord2: '给他人转账',
  usermenu1: '风险补偿赠金',
  usermenu2: '每日成长赠金',
  usermenu3: '账户划转记录',
  usermenu4: '账户转账记录',
  transferbalance1: '现金账户可用余额不足，请修改转账金额',
  proxytransfer1: '您输入的收款人用户ID不存在。',
  walletremark1: '赠金佣金',
  walletremark2: '交易佣金',
  walletremark3: '转账到现金账户',
  proxybonusgroup1: '用户成长赠金报表',
  proxybonusgroup2: '用户风险补偿报表',
  usermenu5: '进入交易系统',
  promotionCenter: '推广中心',
  membershipCenter: '会员中心',
  promotionInviteDisabled: '邀请功能当前未开启',
  promotionCurrentLevel: '当前推广等级',
  promotionValidStatus: '有效用户状态',
  promotionValid: '有效',
  promotionInvalid: '未达到有效用户条件',
  promotionAutoUpgrade: '自动升级',
  promotionEnabled: '已开启',
  promotionDisabled: '已关闭',
  promotionDirectCount: '直接邀请人数',
  promotionDirectValidCount: '有效直推人数',
  promotionTeamCount: '团队总人数',
  promotionTeamValidCount: '团队有效用户',
  promotionInviteCode: '邀请码',
  promotionInviteLink: '邀请链接',
  promotionCopy: '复制',
  promotionCopyLink: '复制链接',
  promotionScanRegister: '扫码注册',
  promotionNextLevel: '下一推广等级',
  promotionRemainingDirect: '还需有效直推',
  promotionRemainingTeam: '还需团队有效用户',
  promotionTradeRatesReadonly: '交易返佣比例（只读）',
  promotionMemberRatesReadonly: '高级会员推广佣金比例（只读）',
  promotionLevel3: '三级代理',
  promotionLevel2: '二级代理',
  promotionLevel1: '一级代理',
  promotionMaster: '主代理',
  promotionNormalUser: '普通用户',
  promotionPremiumMember: '高级会员',
  promotionNormalMember: '普通会员',
  promotionTeam: '推广团队',
  promotionSearchPlaceholder: '用户名 / 用户ID / 交易账号',
  promotionDirectInvite: '直接邀请',
  promotionAllTeam: '全部团队',
  promotionUserId: '用户ID',
  promotionUsername: '用户名',
  promotionLevel: '代理等级',
  promotionMemberLevel: '会员等级',
  promotionValidUser: '有效用户',
  promotionYes: '是',
  promotionNo: '否',
  promotionRegisterTime: '注册时间',
  promotionMyCommission: '我的推广佣金',
  promotionTradeCommission: '交易返佣',
  promotionMemberCommission: '高级会员推广佣金',
  promotionTotalCommission: '累计佣金',
  promotionTradeNo: '交易编号',
  promotionCommissionBase: '返佣计算基数',
  promotionDifferentialRate: '实际级差比例',
  promotionCommissionAmount: '实际佣金',
  promotionTime: '时间',
  promotionMemberOrder: '会员订单',
  promotionSourceUser: '来源用户',
  promotionCopySuccess: '复制成功',
  promotionCopyFailed: '复制失败，请手动复制',
  promotionSystemHint: '新代理体系已启用，用户通过邀请码或邀请链接注册，代理等级由系统自动升级。',
  membershipDisabled: '高级会员功能当前未启用',
  membershipCurrentLevel: '当前会员',
  membershipCashBalance: '现金账户余额',
  membershipExpireTime: '会员到期时间',
  membershipPremium: '高级会员',
  membershipDays: '天',
  membershipPermanent: '永久',
  membershipRenew: '续费高级会员',
  membershipUpgrade: '升级高级会员',
  membershipOrders: '购买记录',
  membershipOrderNo: '订单编号',
  membershipPaidAmount: '支付金额(MEQ)',
  membershipPeriod: '会员期限',
  membershipPurchaseTime: '购买时间',
  membershipConfirmPurchase: '确认使用现金账户支付 {price} MEQ 购买高级会员吗？',
  membershipConfirmTitle: '提示',
  membershipPurchaseSuccess: '购买成功',
  promotionDirectLevel3PlusCount: '直属三级及以上代理',
  promotionDirectLevel2PlusCount: '直属二级及以上代理',
  promotionUpgradeRequirement: '升级条件',
  promotionRequirementDirectValid: '直属有效用户',
  promotionRequirementDirectLevel3Plus: '直属三级及以上代理',
  promotionRequirementDirectLevel2Plus: '直属二级及以上代理',
  promotionCurrentCount: '当前数量',
  promotionRequiredCount: '升级要求',
  promotionRemainingCount: '还需数量',
  promotionRiskGiftCommission: '风险赠金推广佣金',
  promotionGiftAmount: '风险赠金金额',
  usermenu6: '开始交易',
  invitationDetailsV2: '邀请明细',
  commissionDetailsV2: '佣金明细'
}
export default messages
